export default "__VITE_ASSET__im$Of9O___"